import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import NeedsClaim from '../common/NeedsClaim';
import Modal from '../common/Modal';
import stocktakingConfig from './config/stocktakingConfig';
import moment from 'moment';
import auth0 from '../../helpers/auth0';

var StocktakingView = createReactClass({
  getInitialState() {
    return {
      stocktaking: null
    };
  },

  componentWillMount() {
    setViewTitle('Inventur' );
  },

  componentDidMount() {
    request.get({
      url: stocktakingConfig.detailsUrl + this.props.match.params.id,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            stocktaking: data
          });
        }
      }
    });
  },

  finishStocktaking() {
    request.post({
      url: stocktakingConfig.finishUrl + this.props.match.params.id,
      success: () => {
        this.props.history.push('/stocktaking');
      }
    });
  },

  cancelStocktaking() {
    this.cancelModal.show(() =>
      request.del({
        url: stocktakingConfig.cancelUrl + this.props.match.params.id,
        success: () => {
          this.props.history.push('/stocktaking');
        }
      })
    );
  },

  downloadReport() {
    var accessToken = auth0.getAccessToken();

    var downloadUrl = stocktakingConfig.downloadUrl + this.props.match.params.id + '.xlsx?api_key=' + accessToken;

    window.open(downloadUrl);
  },

  render() {
    let { stocktaking } = this.state;

    if (stocktaking == null ) {
      return null;
    }

    var stocktakingContent = stocktaking.hasBeenConfirmed ? this.renderConfirmed(stocktaking) : this.renderUnconfirmed(stocktaking);

    var createdDate = moment(stocktaking.createdDate).format('DD.MM.YYYY HH:mm');
    var confirmedDate = stocktaking.confirmedDate ? moment(stocktaking.confirmedDate).format('DD.MM.YYYY HH:mm') : '-';
    var completedDate = stocktaking.completedDate ? moment(stocktaking.completedDate).format('DD.MM.YYYY HH:mm') : '-';

    return (
      <SimplePage title="Inventur">
        <form className="smart-form">
          <header>
            <div className="col-md-2">{stocktaking.storageLocation}</div>
            <div className="col-md-2">Erstellt am: {createdDate}</div>
            <div className="col-md-2">Bestätigt am: {confirmedDate}</div>
            <div className="col-md-2">Übernommen am: {completedDate}</div>
            <div className="col-md-3 right-content">{stocktaking.user}</div>
            <div className="clearfix"></div>
          </header>
        </form>
        <br />
        {stocktakingContent}

        <br />
      </SimplePage>
    );
  },

  renderConfirmed(stocktaking) {

    var list = stocktaking.items.map(p => {
      var checkCountClassName = p.checkCount > 1 ? 'warning' : '';
      var confirmedQuantityClassName = p.quantity === p.confirmedQuantity ? '' : 'danger';

      return (
        <tr key={p.id}>
          <td>{p.name}</td>
          <td>{p.quantity}</td>
          <td className={confirmedQuantityClassName}>{p.confirmedQuantity}</td>
          <td className={checkCountClassName}>{p.checkCount}</td>
          <td>{p.comment}</td>
        </tr>
      );
    });

    return (
        <div>
            <div className="row">
              <div className="col-md-1 col-md-offset-1">
                <span style={{fontSize: 16}}>
                    {stocktaking.items.length} Artikel
                </span>
              </div>
              <div className="col-md-9 right-content">

                  {!stocktaking.hasBeenCompleted ? (
                    <NeedsClaim claim="stocktaking:write">
                      <button type="button" onClick={this.finishStocktaking} className={`btn btn-primary btn-labeled ${stocktaking.hasBeenCompleted ? 'disabled' : ''}`} >
                        <span className="btn-label"><i className="glyphicon glyphicon-ok"></i></span>
                        <span>Inventur übernehmen</span>
                      </button>
                    </NeedsClaim>) : null}

                  {!stocktaking.hasBeenCompleted ? (
                    <NeedsClaim claim="stocktaking:write">
                      <button type="button" onClick={this.cancelStocktaking} className={`btn btn-danger btn-labeled ${stocktaking.hasBeenCompleted ? 'disabled' : ''}`} >
                        <span className="btn-label"><i className="glyphicon glyphicon-remove"></i></span>
                        <span>Inventur verwerfen</span>
                      </button>
                    </NeedsClaim>) : null}

                  <button type="button" onClick={this.downloadReport} className="btn btn-labeled btn-success" >
                    <span className="btn-label"><i className="glyphicon glyphicon-arrow-down"></i></span>
                    <span>Herunterladen</span>
                  </button>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-md-offset-1 col-md-10">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Artikelname</th>
                        <th>Anzahl</th>
                        <th>Bestätigte Anzahl</th>
                        <th>Versuche</th>
                        <th>Kommentar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Modal
              ref={c => this.cancelModal = c}
              title="Inventur wirklich verwerfen?"
              message={`Soll die Inventur wirklich verworfen werden? Diese Aktion kann nicht rückgängig gemacht werden.`}
              confirmButtonText="Ja, verwerfen"
            />
        </div>

    );
  },

  renderUnconfirmed(stocktaking) {

    var list = stocktaking.items.map(p =>
        <tr key={p.id}>
          <td>{p.name}</td>
          <td>{p.quantity}</td>
        </tr>
    );

    return (
      <div className="row">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Artikelname</th>
                  <th>Anzahl</th>
                </tr>
              </thead>
              <tbody>
                {list}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
});

export default StocktakingView;



// WEBPACK FOOTER //
// ./src/components/stocktaking/StocktakingView.js